// extracted by mini-css-extract-plugin
export default {"typeContainer":"TypesSection-module__typeContainer--H1LvT"};